/*
 * @Description: 订单利润生成记录
 * @Author: 杨志航
 * @Date: 2026-08-13 11:29:58
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Table,
} from 'antd'

const ChangeLog = (props) => {
  const { id } = props
  const [logList, setLogList] = useState([])

  useEffect(() => {
    api.getOrderProfitChangeLog({
      id,
      limit: global.paramsLimit,
    }).then(data => {
      setLogList(data.list)
    })
  }, [])

  const logCol = [{ 
    title: '消耗市场价', 
    dataIndex: 'consumption_amount',
    align: 'center',
  }, { 
    title: '订单编号', 
    dataIndex: 'order_number',
    align: 'center',
  }, { 
    title: '一返', 
    dataIndex: 'new_first_rebate',
    align: 'center',
  }, { 
    title: '二返', 
    dataIndex: 'new_second_rebate',
    align: 'center',
  }, { 
    title: '订单利润', 
    dataIndex: 'new_order_profit',
    align: 'center',
  }, { 
    title: '返点来源', 
    dataIndex: 'new_rebate_source_name',
    align: 'center',
  }, { 
    title: '更新人', 
    dataIndex: 'operator_name',
    align: 'center',
  }, { 
    title: '更新时间', 
    dataIndex: 'create_time',
    align: 'center',
  }]

  return (
    <div>
      <Table 
        rowKey={(record, i) => i}
        columns={logCol} 
        dataSource={logList}
        pagination={false}
        size="middle"
      />
    </div>
  )
}

export default ChangeLog
